import { useLang } from '../../../../../../hooks/use-lang';
import { useToggle } from '../../../../../../hooks/use-toggle';
import { AdminType } from '../../../../../../store/api/admins-api';

export interface RolesDictionaryAdminsProps {
  role: string;
  admins: AdminType[];
}

export const useRolesDictionaryAdmins = () => {
  const { t, getLocale } = useLang();
  const [collapse, toggleCollapse] = useToggle();

  return {
    t,
    getLocale,
    collapse,
    toggleCollapse,
  };
};
